import Content from "./components/Content";
import Navbar from "./components/Navbar";


function App() {
  return (
    <>
      <Navbar />
      <Content />
    </>
  );
}

export default App;
